module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPHBhdGggZD0iTTAgMGg1MTJ2NTEySDB6IiBmaWxsPSIjMjE0NjhiIi8+CiAgPHBhdGggZD0iTTAgMGg1MTJ2MzQxLjNIMHoiIGZpbGw9IiNmZmYiLz4KICA8cGF0aCBkPSJNMCAwaDUxMnYxNzAuN0gweiIgZmlsbD0iI2FlMWMyOCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/bq.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/bq.svg
// module chunks = 0